import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import FeaturedHotels from '../components/FeaturedHotels';
import PopularDestinations from '../components/PopularDestinations';
import Footer from '../components/Footer';
import LoginModal from '../components/LoginModal';
import { toast } from 'react-toastify';
import { getHeroBannerImageUrls } from '../config/heroBannerImages';
import './LandingPage.css';

const heroImages = getHeroBannerImageUrls();

const LandingPage = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [currentHeroImage, setCurrentHeroImage] = useState(0);

  useEffect(() => {
    if (sessionStorage.getItem('workspaceSessionExpired') === '1') {
      sessionStorage.removeItem('workspaceSessionExpired');
      toast.info('Your workspace session has ended. You can continue browsing stays or sign in again.');
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-advance hero images
  useEffect(() => {
    if (heroImages.length <= 1) return undefined;
    const interval = setInterval(() => {
      setCurrentHeroImage((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const handleBookMeetingRoom = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem('authRedirectPath', '/meeting-home');
    navigate('/meeting-home', { replace: false });
  };

  return (
    <div className="landing-page">
      <Navbar isScrolled={isScrolled} onSignInClick={() => setIsLoginModalOpen(true)} showLoginModal={true} />
      <div className="landing-page-main">
      <HeroBanner 
        images={heroImages} 
        currentImage={currentHeroImage}
        onImageChange={setCurrentHeroImage}
      />

      {/* Meeting Room Booking Section */}
      <section className="meeting-room-section">
        <div className="meeting-room-container">
          <motion.div
            className="meeting-room-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="meeting-room-image-container">
              <img 
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80" 
                alt="Professional Meeting Room"
                className="meeting-room-image"
              />
            </div>
            <div className="meeting-room-content">
              <h3 className="meeting-room-title">Meeting Room Booking</h3>
              <p className="meeting-room-description">
                Interviews • Conferences • Team meetings
              </p>
              <p className="meeting-room-subdescription">
                Book professional meeting rooms for interviews, team meetings, presentations & conferences.
              </p>
              <div className="meeting-room-pricing">
                <span className="pricing-option">Hourly</span>
                <span className="pricing-separator">|</span>
                <span className="pricing-option">Half day</span>
                <span className="pricing-separator">|</span>
                <span className="pricing-option">Full day</span>
              </div>
              <button 
                className="meeting-room-cta"
                onClick={handleBookMeetingRoom}
              >
                Book Meeting Room
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      <FeaturedHotels />
      <PopularDestinations />
      <Footer />
      </div>
      <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
    </div>
  );
};

export default LandingPage;


